/**
 * Created by hw_liu on 2017/10/30 .
 */
function checkUrl (isWechat) {
  if (isWechat) {
    return WECHAT_URL;
  } else {
    return API_URL;
  }
}

function send (config) {
  let options = Object.assign({
    url: config.url,
    method: config.method,
    params: config.params,
    data: config.data
  }, {
    headers: {
      'Content-Type': config.contentType ? config.contentType : 'application/x-www-form-urlencoded'
    },
    withCredentials: true,
    baseURL: checkUrl(config.isWechat)
  })

  config.http(options)
    .then(response => {
      // console.log(`${config.method} ${config.url} ${response.status}: ${JSON.stringify(response.data)}`);

      if (config.success) {
        config.success(response.data)
      }
    })
    .catch(function (error) {
      if (error.response) {
        // 请求已发出，但服务器响应的状态码不在 2xx 范围内
        console.error(`${config.method} ${config.url} ${error.response.status}: ${error.response.data.errmsg}`);
        if (config.error) {
          config.error(error.response.data)
        }
      } else {
        // Something happened in setting up the request that triggered an Error
        console.error('Error: ', error.message);
      }
    });
}

function absoluteUrl (url) {
  if (typeof url === 'undefined' || url === null
    || Object.prototype.toString.call(url) !== '[object String]') {
    throw 'illegal url';
  }

  if (url.startsWith("/")) return API_URL + url;
  else return API_URL + '/' + url;
}

export default  {
  absoluteUrl: absoluteUrl,
  get: function (config) {
    send(Object.assign({
      method: 'GET',
    }, config))
  },
  post: function (config) {
    send(Object.assign({
      method: 'POST'
    }, config));
  },
  delete: function (config) {
    send(Object.assign({
      method: 'DELETE'
    }, config));
  },
  patch: function (config) {
    if (!config.params) config.data = {};
    config.data = config.params;
    delete config.params;
    send(Object.assign({
      method: 'PATCH',
      contentType: 'application/json'
    }, config));
  }
};



// WEBPACK FOOTER //
// ./src/assets/javascripts/ajax.js